import { ReactNode } from "react";
import { 
  Flex
 } from "@chakra-ui/react";

type Props = {
  children?: ReactNode;
};

export default function Layout({ children }: Props) {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      h="100%"
      bg="pink.400"
      pb={10}
      pt={10}
    >
      {children}
    </Flex>
  );
}
